import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Feed from "./components/Feed";
import Reversal from "./components/Reversal";
import Timeline from "./components/Timeline";
import DeepRead from "./components/DeepRead";
import Faq from "./components/Faq";
import About from "./components/About";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Feed />
        <Reversal />
        <Timeline />
        <DeepRead />
        <Faq />
        <About />
        <Newsletter />
      </main>
      <Footer />
    </>
  );
}